import { CSSProperties } from 'react';
import { COLORS } from '~/data/ui/colors';

export const autoCompleteStyle = {
  direction: 'rtl',
  border: 'none',
  '& .MuiAutocomplete-input': {
    color: COLORS.black.dark,
    border: 'none',
  },
  '& ::placeholder': {
    color: COLORS.gray.dark,
    opacity: 1,
    fontSize: '16px',
  },
  '& .MuiInputBase-root': {
    borderRadius: '8px',
    '& .MuiAutocomplete-endAdornment ': {
      right: '90%',
    },
  },
};

export const autocompleteLabelStyles: CSSProperties = {
  fontSize: '12px',
  fontWeight: '500px',
  lineHeight: '1.6',
  color: COLORS.black.dark,
};
